/**
 * 优惠券审核状态
 * @params string 优惠券状态码  // 优惠券状态(0不可用,1可使用,2已过期,3已作废，4草稿)
 */
export default function couponStatus(val) {
    let str = '';
    switch (val) {
    case 0:
        str = '不可用';
        break;
    case 1:
        str = '可使用';
        break;
    case 2:
        str = '已过期';
        break;
    case 3:
        str = '已作废';
        break;
    case 4:
        str = '草稿';
        break;
    default:
        break;
    }
    return str;
}
